
import { Injectable } from '@angular/core';
import { environment } from '../../..//environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {
  apiUrl2 = `${environment.API_URL2}` ;
	constructor( private http: HttpClient) {}
  
  getAllCountry(){
    return this.http.get(`${this.apiUrl2}/master/getCountries`);
  }

  getAllState(){
    return this.http.get(`${this.apiUrl2}/master/getStates`);
  }
  getAllCities(){
    return this.http.get(`${this.apiUrl2}/master/getAllCities`);
  }
  getCountryByState(id){
    return this.http.get(`${this.apiUrl2}/master/getCountryByState/${id}`);
  }
  getStateByCountry(id){
    return this.http.get(`${this.apiUrl2}/master/getStateByCountry/${id}`);
  }
  getStateByCity(id){
    return this.http.get(`${this.apiUrl2}/master/getStateByCity/${id}`);
  }
  getCityByState(id){
    return this.http.get(`${this.apiUrl2}/master/getCityByState/${id}`);
  }
 
  getCountryStateByPIN(id){
    return this.http.get(`${this.apiUrl2}/master/getCountryStateByPIN/${id}`);
  }
}